import demandService from '@/service/demand';
import localforage from 'localforage';
import { observable, action, runInAction } from 'mobx';


// 切换招聘量TOP30表格图表

const moHotRole = observable({
  quantityType: 'chart',
  heatType: 'chart',
  quantityActive: 2022,
  heatActive: 2022,
  hotListTop10: <any>[],
  hotListTop30: <any>[],
  timeList: <any>[],
  Xvlaue: "axis_amount",
  Yvlaue: "axis_amount_change",
});

// 切换招聘热度Top10表格图表

const changeQuantityType = action(async (val: string) => {
  runInAction(() => {
    moHotRole.quantityType = val;
  })
  const local: any = await localforage.getItem('demand') || {};
  local['quantityType'] = val;
  localforage.setItem('demand', local)
})


// 切换招聘趋势表格图表

const changeHeatType = action(async (val: string) => {
  runInAction(() => {
    moHotRole.heatType = val;
  })
  const local: any = await localforage.getItem('demand') || {};
  local['heatType'] = val;
  localforage.setItem('demand', local)
})


// 修改时间

const changeHeatTime = action(async (val: any) => {
  runInAction(() => {
    moHotRole.heatActive = val;
  })
  const top10 = await demandService.getRankTop10({ time_option: val })
  runInAction(() => {
    moHotRole.hotListTop10 = top10;
  })
  const local: any = await localforage.getItem('demand') || {};
  local['heatActive'] = val;
  localforage.setItem('demand', local)
})


// 修改时间

const changeQuantityTime = action(async (val: any) => {
  runInAction(() => {
    moHotRole.quantityActive = val;
  })
  const top30 = await demandService.getRankTop30({ time_option: val })
  runInAction(() => {
    moHotRole.hotListTop30 = top30;
  })
  const local: any = await localforage.getItem('demand') || {};
  local['quantityActive'] = val;
  localforage.setItem('demand', local)
})

// 获取热门top10
const getRankTop10 = action(async () => {
  const top10 = await demandService.getRankTop10({ time_option: moHotRole.heatActive })
  runInAction(() => {
    moHotRole.hotListTop10 = top10;
  })
})

// 获取热门top30

const getRankTop30 = action(async () => {
  const top30 = await demandService.getRankTop30({ time_option: moHotRole.quantityActive })
  runInAction(() => {
    moHotRole.hotListTop30 = top30;
  })
})

// 获取时间列表
const getTimeListTop = action(async () => {
  const local: any = await localforage.getItem('demand') || {};
  const timeList = await demandService.getTimeListTop()
  runInAction(() => {
    moHotRole.timeList = timeList;
    moHotRole.quantityActive = local['quantityActive'] ? local['quantityActive'] : timeList[timeList.length - 1];
    moHotRole.heatActive = local['heatActive'] ? local['heatActive'] : timeList[timeList.length - 1];
  })
})

// 修改x轴
const changex = action(async(val: string) => {
  runInAction(() => {
    moHotRole.Xvlaue = val
  })
  const local: any = await localforage.getItem('demand') || {};
  local['Xvlaue'] = val;
  localforage.setItem('demand', local)
})

// 修改y轴
const changey = action(async(val: string) => {
  runInAction(() => {
    moHotRole.Yvlaue = val
  })
  const local: any = await localforage.getItem('demand') || {};
  local['Yvlaue'] = val;
  localforage.setItem('demand', local)
})


export default moHotRole;
export {
  changeHeatType, changeQuantityType, changeHeatTime, changeQuantityTime, getRankTop10, getRankTop30,
  getTimeListTop, changex, changey
};
